@if (depositService.showODpopUp()) {
    <div class="mt-2 mb-2 space-between">
        <p class="text-bold">{{ 'PARTY.CASHIER.web.deposit.occu.hdr' | translate }}</p>
        <a (click)="close('skip')" class="cursor-pointer">
            <u>{{ 'PARTY.CASHIER.web.deposit.occu.link' | translate }}</u>
        </a>
    </div>
    <span>{{ 'PARTY.CASHIER.web.deposit.occu.msg1' | translate }}</span>
    <button (click)="redirectToODpage()" type="submit" class="btn btn-primary mt-3 mb-2 w-100">
        {{ 'PARTY.CASHIER.web.deposit.occu.button1' | translate }}
    </button>
    <button (click)="close('remind me later')" type="submit" class="btn w-100 btnBorder">
        {{ 'PARTY.CASHIER.web.deposit.occu.button2' | translate }}
    </button>
}
